import { icons } from "assets/icons";
import IconButton from "components/Button/IconButton";
import { useRolesListStore, useUserRolePermissionStore } from "contexts/RootStore.context";
import { Horizontal } from "gls/lib";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { configRoutePath } from "router/routePaths";
import { colours } from "styling/colours";
import { style } from "typestyle";
import { ErrorResponseDto } from "api/config/ErrorResponseDto";
import { alertErrorMessage } from "utils/alerts";
import { RoleListItem } from "../../RoleConfigDto";

export type TaskTypeListRowProps = {
  role: RoleListItem;
};

export const RowActions = observer(({ role }: TaskTypeListRowProps) => {

  const navigate = useNavigate();
  const { canManageWorkgroupRoles, canManageGroupsAndRoles } = useUserRolePermissionStore()

  const manageAccess = canManageGroupsAndRoles || canManageWorkgroupRoles;
  const {
    setDeleteModalOpen,
    setActionLoading,
    loadAssociatedUsers,
    setRoleToDelete

  } = useRolesListStore();

  const handleDeleteRole = async (role: RoleListItem) => {
    setDeleteModalOpen(true);
    setActionLoading(true);
    loadAssociatedUsers(role)
      .then(() => {
        setRoleToDelete(role);
        setActionLoading(false);
      })
      .catch((error: ErrorResponseDto) => {
        setDeleteModalOpen(false);
        setActionLoading(false);
        alertErrorMessage(error.errorMsg)
      });
  }

  return (

    <Horizontal
      spacing={18}
      verticalAlign="center"
      horizontalAlign="right"
      className={paddingStyle}
    >
      <IconButton
        ariaLabel={manageAccess ? `edit row` : `view row`}
        id={manageAccess ? `button-edit` : `button-view`}
        fill={colours.secondary}
        icon={
          manageAccess ? (
            <icons.EditIconOutlined
              aria-label="Edit Row"
              width={18}
              height={18}
              fill={colours.secondary}
            />
          ) : (
            <icons.OpenEyeIcon
              aria-label="View Row"
              width={18}
              height={18}
              fill={colours.secondary}
            />
          )
        }
        onClick={() => {
          navigate(`${configRoutePath.editRole}/${role.id}`);
        }}
      />
      {manageAccess && (
        <IconButton
          ariaLabel="Delete Row"
          id="button-delete"
          icon={<icons.OutlineDeleteIcon aria-label="Delete Row" />}
          onClick={() => {
            handleDeleteRole(role)
          }}
        />
      )}
    </Horizontal>
  );
});

const paddingStyle = style({
  padding: "20px 0",
});


